import { isWeekend } from "~/libs/isWeekend";
import { addDays } from "date-fns";

export const getCloseWeekday = (date) =>
  !isWeekend(date) ? date : getCloseWeekday(addDays(new Date(date), 1));
